<template>
  <div>
    <template v-for="(button, index) in visibleButtons">
      <el-button size="mini" @click="button.click" :key="index" :disabled="!button.isShow">{{
        button.text
      }}</el-button>
    </template>
    <el-dropdown v-if="showMore" class="ml-10px">
      <el-button size="mini">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      <el-dropdown-menu slot="dropdown">
        <template v-for="(button, index) in hiddenButtons">
          <el-dropdown-item @click.native="button.click" :disabled="!button.isShow" :key="index">{{
            button.text
          }}</el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'table-operate-button',
  props: {
    // 按钮列表
    buttons: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    // 显示的按钮列表
    visibleButtons() {
      if (this.buttons.length < 4) {
        return this.buttons
      }
      return this.buttons.slice(0, 3)
    },
    // 放到dropdown里面的按钮
    hiddenButtons() {
      if (this.buttons.length < 4) {
        return []
      }
      return this.buttons.slice(3)
    },
    // 是否显示dropdown更多按钮
    showMore() {
      return this.buttons.length >= 4
    },
  },
}
</script>

<style></style>
